var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 42,
    viewBox: "0 0 47 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.51116 27.3H13.4286V14.7H4.51116C1.9933 14.7 0 16.59 0 18.9V23.1C0 25.41 1.9933 27.3 4.51116 27.3Z",
    fill: "#006BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4397 26.25C44.4821 26.25 47 23.94 47 21C47 18.06 44.4821 15.75 41.4397 15.75V26.25Z",
    fill: "#006BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9287 0C35.6698 0 34.7256 0.945 34.7256 2.1V39.9C34.7256 41.055 35.7747 42 36.9287 42C38.0827 42 39.1318 41.055 39.1318 39.9V2.1C39.1318 0.945 38.1876 0 36.9287 0Z",
    fill: "#006BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4287 18.9C21.8216 18.9 29.48 15.54 34.7256 9.66001V2.10001C30.9488 9.55501 22.8707 14.7 13.4287 14.7V18.9Z",
    fill: "#0AE8F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4287 23.1V27.3C22.7658 27.3 30.8439 32.445 34.7256 39.9V23.1H13.4287Z",
    fill: "#0AE8F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4286 18.9H4.51123V23.1H13.4286V18.9Z",
    fill: "#006BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5693 40.635L14.268 29.4H7.13403L11.7501 41.265C11.855 41.685 12.3796 42 12.7992 42H17.5202C18.2546 42 18.7791 41.265 18.5693 40.635Z",
    fill: "#BDCCD4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.2a210399d79a9e634bc043c1ac626e79.svg";
export { ForwardRef as ReactComponent };